import { graphql } from '@/graphql';

export const featuresByLayerQuery = graphql(`
  query features($layerIds: [ID!]!) {
    featuresByLayer(layerIds: $layerIds) {
      id
      serial
      layerId
      geometryWGS84
      geometry
      properties
    }
  }
`);

export const featureQuery = graphql(`
  query Feature($id: ID!) {
    feature(id: $id) {
      id
      serial
      layerId
      geometryWGS84
      geometry
      properties
    }
  }
`);

export const createFeatureMutation = graphql(`
  mutation CreateFeature($input: CreateFeatureInput!) {
    createFeature(input: $input) {
      id
      serial
      layerId
      geometryWGS84
      geometry
      properties
    }
  }
`);

export const updateFeatureMutation = graphql(`
  mutation UpdateFeature($input: UpdateFeatureInput!) {
    updateFeature(input: $input) {
      id
      serial
      layerId
      geometryWGS84
      geometry
      properties
    }
  }
`);

export const featuresByIdsQuery = graphql(`
  query FeaturesByIds($ids: [ID!]!) {
    featuresByIds(ids: $ids) {
      id
      serial
      layerId
      properties
    }
  }
`);

export const updateFeaturesMutation = graphql(`
  mutation UpdateFeatures($input: [UpdateFeatureInput!]!) {
    updateFeatures(input: $input) {
      id
      serial
      layerId
      properties
    }
  }
`);

export const deleteFeatureMutation = graphql(`
  mutation DeleteFeature($id: ID!) {
    deleteFeature(id: $id)
  }
`);

export const deleteFeaturesMutation = graphql(`
  mutation DeleteFeatures($ids: [ID!]!) {
    deleteFeatures(ids: $ids)
  }
`);

export const sridsQuery = graphql(`
  query Srids {
    srids {
      srid
      name
      projection
    }
  }
`);

export const featuresPaginatedQuery = graphql(`
  query featuresPaginated($projectId: ID!, $layerId: ID, $cursor: String, $orderBy: FeatureOrder, $limit: Int!, $filters: [FeatureFilter!], $query: String) {
    featuresPaginated(limit: $limit, projectId: $projectId, layerId: $layerId, cursor: $cursor, orderBy: $orderBy, filters: $filters, query: $query) {
      features {
        id
        serial
        properties
        layerId
      }
      total
      cursor
    }
  }
`);

export const featureSummaryQuery = graphql(`
  query FeatureSummary($layerId: ID!, $filters: [FeatureFilter!], $query: String) {
    featureSummary(layerId: $layerId, filters: $filters, query: $query) {
      pointCount
      lineCount
      polygonCount
      totalLineLengthM
      totalPolygonAreaSqm
      totalPolygonPerimeterM
    }
  }
`);

export const featureAttachmentsQuery = graphql(`
  query FeatureAttachments($featureId: ID!) {
    featureAttachments(featureId: $featureId) {
      id
      label
      uploadedById
      attachmentId
      attachment {
        id
        url
        filename
        contentType
        contentLength
      }
      uploadedBy {
        id
        name
        email
        avatar {
          url
        }
      }
      createdAt
      updatedAt
    }
  }
`);

export const createFeatureAttachmentMutation = graphql(`
  mutation CreateFeatureAttachment($input: CreateFeatureAttachmentInput!) {
    createFeatureAttachment(input: $input) {
      id
      label
      uploadedById
      attachmentId
      attachment {
        id
        url
        filename
        contentType
        contentLength
      }
      createdAt
    }
  }
`);

export const deleteFeatureAttachmentMutation = graphql(`
  mutation DeleteFeatureAttachment($id: ID!) {
    deleteFeatureAttachment(id: $id)
  }
`);

export const downloadFeaturesMutation = graphql(`
  mutation DownloadFeatures($ids: [ID!], $layerId: ID, $exportType: ExportType!) {
    downloadFeatures(ids: $ids, layerId: $layerId, exportType: $exportType)
  }
`);
